module.exports = __webpack_public_path__ + "static/media/bidspotter-co-uk_logo.e1136241.png";